import { render } from "./EditUserDataModal.vue?vue&type=template&id=095ef5aa"
import script from "./EditUserDataModal.vue?vue&type=script&lang=js"
export * from "./EditUserDataModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/settings/settings-modals/EditUserDataModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "095ef5aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('095ef5aa', __exports__)) {
    api.reload('095ef5aa', __exports__)
  }
  
  module.hot.accept("./EditUserDataModal.vue?vue&type=template&id=095ef5aa", () => {
    api.rerender('095ef5aa', render)
  })

}


export default __exports__